import script from "./AdminPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPanel.vue?vue&type=script&setup=true&lang=js"

import "./AdminPanel.vue?vue&type=style&index=0&id=5e7a01b2&lang=scss"

const __exports__ = script;

export default __exports__